import React, { useEffect, useState } from 'react';
import { Alert, Button } from 'react-bootstrap';
import api from '../config/axiosConfig';
import {Link} from 'react-router-dom';
import { readPayload } from '../utils/dataUtils';
import { getErrorMessage } from '../utils/apiResponseUtils';

export default function CustomerHomeContent() {
  const [data, setData] = useState(null);
  const [error, setError] = useState('');
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    let active = true;
    setError('');
    api.get('/content/home').then(response => { if (active) setData(readPayload(response)); })
      .catch(err => { if (active) setError(getErrorMessage(err, 'Unable to load customer support details.')); });
    return () => { active = false; };
  }, [attempt]);
  return <section className="customer-panel" aria-label="Customer support">
    <h2>Customer support</h2><p><Link to="/dashboard/support">Submit a support ticket</Link> � <a href="mailto:redgaady@gmail.com">redgaady@gmail.com</a></p>
    {error && <Alert variant="warning">{error} <Button variant="link" onClick={() => setAttempt(value => value + 1)}>Retry support details</Button></Alert>}
    {!data && !error && <p role="status">Loading support details...</p>}
    {data && <><p>Support: {data.support?.phone || data.supportPhone || 'Contact support for assistance.'}</p><p>Referral: {data.referral?.code || data.referralCode || 'No referral code available.'}</p></>}
  </section>;
}
